import cn from 'classnames';
import sanitizeHtml from 'sanitize-html';

import { getClientOptions } from 'scripts/clients/index'

import PostQuestion from 'popups/PostQuestion';

import useModal from 'hooks/useModal';
import { useClientContext, useTranslationContext } from 'hooks';

import classes from './SubHeader.module.scss';

export default function SubHeader() {
  const { client } = useClientContext();
  const { t, translateCustomText, language } = useTranslationContext();
  const { visible, toggle } = useModal();

  const customText = getClientOptions(client)?.customText?.askQuestion || null;
  const buttonSuffix = customText?.buttonSuffix || null;

  const defaultQuestionText = `${t("Have something to ask")} ${client?.firstName || ''}?`;

  const getQuestionTextTranslation = () => {
    if (language !== 'en' && client.translations && client.translations[language])
      return (client.translations[language].postQuestionText || client.postQuestionText || defaultQuestionText) + ' ';
    return (client.postQuestionText || defaultQuestionText) + ' ';
  }

  const cleanText = (dirty: string) => {
    const clean = sanitizeHtml(dirty, {
      allowedTags: ['br'],
      allowedAttributes: {}
    });

    return (
      <div dangerouslySetInnerHTML={{__html: clean}} />
    );
  };

  return (
    <div className={cn(classes.SubHeader, 'SubHeader')}>
      <div className={classes.home}>
        {cleanText(getQuestionTextTranslation().replace(/\\n/, '<br/>'))}

        <button id="new_question" type="button" onClick={toggle} style={{ backgroundColor: client?.newQuestionColour }}>
          {translateCustomText("postQuestionBtnText", t("Post a new Question"))}
        </button>

        {buttonSuffix && <div>{buttonSuffix}</div>}

        <PostQuestion visible={visible} toggle={toggle} />
      </div>
    </div>
  );
}
